import { Component, OnInit, Input } from '@angular/core';
import { ResidentialService } from '../../residential.service';
import * as _ from 'underscore';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group
} from '@angular/animations';

@Component({
  selector: 'app-r-q15',
  templateUrl: './r-q15.component.html',
  styleUrls: ['./r-q15.component.css', '../residential-question.component.css'],
  animations: [
    trigger('flyInOut', [
      state('in', style({
        transform: 'translateX(0)', opacity: 1
      })),
      transition('void => *', [
        style({transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate('0.4s 0.1s ease', style({
            transform: 'translateX(0)',
          })),
          animate('0.4s ease', style({
            opacity: 1
          }))
        ])
      ]),
      transition('* => void', [
        group([
          animate('0.4s ease', style({
            transform: 'translateX(50px)',
          })),
          animate('0.4s 0.2s ease', style({
            opacity: 0
          }))
        ])
      ])
    ]),
    trigger('flyOut', [
      state('out', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(-100%)' }),
        animate(100)
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(100%)' }))
      ])
    ]),
    trigger('flyOutans', [
      state('in', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(100%)' }),
        animate(100)
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(0%)' }))
      ])
    ])
  ]
})
export class RQ15Component implements OnInit {
  type;
  @Input() data: any;
  isDisable;
  showTip;
  question;
  isChecked = false;
  showbutton = true;
  questions;
  userResponses = [];
  index;
  questionObj;
  // for checkbox
  hgType = {
    gas: false,
    electricity: false
  };
  property;
  messagetype;
  deviceWidth;
  user_bot;
  heating1_id;
  heating2_id;
  gas_src;
  elec_src;
  timer;
  showTyping = false;
  typingTimer;
  time = 1000;

  constructor(private residentialService: ResidentialService) {
    this.questions = this.residentialService.getQues();
    this.userResponses = this.residentialService.userResponse.userResponses;
    this.property = this.residentialService.property;
    this.deviceWidth = this.residentialService.deviceWidth;
  }

  goNext() {
    clearTimeout(this.timer);
    if (this.deviceWidth < 768) {
      if (this.showTip) {
        if (this.typingTimer) {
        clearTimeout(this.typingTimer);
        this.showTyping = false;
      }
      this.typingTimer = setTimeout(() => {
        this.showTyping = true;
      }, 250);
      this.time = 2000;
    }
      this.timer = setTimeout(() => {
        this.showTyping = false;
        this.next();
      }, 0);
    }
  }

  ngOnInit() {
    this.residentialService.currentId = this.data;
    // check the flow is renewal
    if (this.residentialService.questionFlowType === 'renewal') {
      this.residentialService.messageService({ 'nextId': '0016' });
    } else {
      if (this.deviceWidth < 768) {
        this.heating1_id = document.getElementById('Gas_mob');
        this.heating2_id = document.getElementById('Electricity_mob');
      } else {
        this.heating1_id = document.getElementById('Gas');
        this.heating2_id = document.getElementById('Electricity');
      }
      for (let i = 0; i < this.questions.length; i++) {
        if (this.questions[i]._id === this.data) {
          this.question = this.questions[i].res_question;
          this.questionObj = this.questions[i];
          this.index = i;
        }
      }
      if (!_.isEmpty(this.property)) {
        if (this.property === 'Apartment or condominium') {
          this.question = this.question.replace('home', 'apartment');
        }
      }
      if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj)) {
        const obj = _.findWhere(this.userResponses, { 'res_question_id': this.questionObj._id });
        if (!_.isEmpty(obj)) {
          this.type = obj.fieldValue;
          if (!_.isEmpty(this.type)) {
            this.isChecked = true;
            this.user_bot = true;
            if (this.type === 'Gas') {
              this.gas_src = 'assets/images/gas-pink.png';
              this.elec_src = 'assets/images/electricity-gray.png';
              this.hgType = {
                gas: true,
                electricity: false
              };
              this.showTip = false;
              this.heating1_id.parentElement.parentElement.classList.add('active-select');
            } else {
              this.gas_src = 'assets/images/gas-gray.png';
              this.elec_src = 'assets/images/electricity-pink.png';
              this.hgType = {
                gas: false,
                electricity: true
              };
              this.showTip = true;
              this.heating2_id.parentElement.parentElement.classList.add('active-select');
            }
            if (this.deviceWidth < 768) {
              this.goNext();
            }
          } else {
            this.gas_src = 'assets/images/gas-gray.png';
            this.elec_src = 'assets/images/electricity-gray.png';
          }
        } else {
          this.gas_src = 'assets/images/gas-gray.png';
          this.elec_src = 'assets/images/electricity-gray.png';
        }
      }
      this.messagetype = this.residentialService.messervicetype;
    }

    if (!this.hgType.gas && !this.hgType.electricity)
    {
      this.showbutton = false;
    }
  }

  getType(event) {
    this.type = event.target.value;
    this.isChecked = event.target.checked;
    if (this.isChecked === true) {
      if (!_.isEmpty(this.type)) {
        // this.showTip = true;
        if (this.deviceWidth < 768) {
          this.residentialService.unSelectService({'currentId': this.data});
        }
        if (this.type === 'Gas') {
          this.gas_src = 'assets/images/gas-pink.png';
          this.elec_src = 'assets/images/electricity-gray.png';
          this.hgType = {
            gas: true,
            electricity: false
          };
          this.showTip = false;
          this.heating1_id.parentElement.parentElement.classList.add('active-select');
          if (_.contains(this.heating2_id.parentElement.parentElement.classList, 'active-select')) {
            this.heating2_id.parentElement.parentElement.classList.remove('active-select');
          }
        } else {
          this.gas_src = 'assets/images/gas-gray.png';
          this.elec_src = 'assets/images/electricity-pink.png';
          this.hgType = {
            gas: false,
            electricity: true
          };
          this.showTip = true;
          this.heating2_id.parentElement.parentElement.classList.add('active-select');
          if (_.contains(this.heating1_id.parentElement.parentElement.classList, 'active-select')) {
            this.heating1_id.parentElement.parentElement.classList.remove('active-select');
          }
        }
        this.user_bot = true;
        if (this.deviceWidth < 768) {
          this.goNext();
        }
      }
    } else {
      this.gas_src = 'assets/images/gas-gray.png';
      this.elec_src = 'assets/images/electricity-gray.png';
      this.hgType = {
        gas: false,
        electricity: false
      };
      this.type = '';
      this.showTip = false;
      if (_.contains(this.heating2_id.parentElement.parentElement.classList, 'active-select')) {
        this.heating2_id.parentElement.parentElement.classList.remove('active-select');
      }
      if (_.contains(this.heating1_id.parentElement.parentElement.classList, 'active-select')) {
        this.heating1_id.parentElement.parentElement.classList.remove('active-select');
      }
      this.user_bot = false;
      if (this.deviceWidth < 768) {
        this.residentialService.unSelectService({'currentId': this.data});
      }
    }
    this.save();

    if (this.isChecked === true) 
    {
      if (this.deviceWidth < 768) {
      }
      else
      {
        if(!this.showbutton)
        {
          this.next();
        }

      }

    }
  }
  
  next() {
    if (_.isEmpty(this.type)) {
      // console.log.log(this.type);
      // alert('Select the Option');
    } else {
      this.residentialService.messageService({ 'currentId': this.data });
    }
  }
  // This function is used for to save the data in DB
  save() {
    const Obj = {
      'res_question_id': this.data, 'fieldName': 'heating_type', 'fieldValue': this.type
    };
    this.residentialService.updateResponses(Obj);
  }
}


